<template>
  <div v-if="author">
    <div class="bg-white rounded-3xl border border-light-gray p-6 ui-font">
      <div class="flex items-center justify-between mb-4">
        <h3 class="text-lg lg:text-2xl font-bold leading-tight">
          Profile<br />
          completeness
        </h3>

        <span class="text-yka-blue font-bold text-xl lg:text-3xl">
          {{ profileCompletion.percentage }}%
        </span>
      </div>

      <div
        class="relative w-full h-3 rounded-full overflow-hidden mb-6 bg-lighter-gray"
      >
        <div
          class="absolute top-0 left-0 h-full bg-yka-blue rounded-full transition-all duration-500"
          :style="{ width: profileCompletion.percentage + '%' }"
        ></div>
      </div>

      <p class="mb-6">A complete profile helps readers trust and follow you.</p>

      <ul class="space-y-4 text-lg">
        <li
          class="flex items-center gap-3 text-sm"
          :class="
            profileCompletion.hasDisplayName
              ? 'line-through text-light-gray'
              : 'text-dark-gray'
          "
        >
          {{ profileCompletion.hasDisplayName ? "✓" : "○" }}
          Display name
        </li>

        <li
          class="flex items-center gap-3 text-sm"
          :class="
            profileCompletion.hasDescription
              ? 'line-through text-light-gray'
              : 'text-dark-gray'
          "
        >
          {{ profileCompletion.hasDescription ? "✓" : "○" }}
          Short description
        </li>

        <li
          class="flex items-center gap-3 text-sm"
          :class="
            profileCompletion.hasProfilePhoto
              ? 'line-through text-light-gray'
              : 'text-dark-gray'
          "
        >
          {{ profileCompletion.hasProfilePhoto ? "✓" : "○" }}
          Add a profile photo
        </li>
      </ul>
    </div>
    <!-- ACCOUNT CARD -->
    <div class="ui-font rounded-3xl border border-light-gray p-6 mt-5">
      <label class="profile-label"> ACCOUNT </label>

      <ul class="space-y-5">
        <li>
          <router-link to="/request-new-feature" class="sidebar-link">
            <span>Request a new feature</span>
            <span>›</span>
          </router-link>
        </li>

        <li>
          <router-link to="/privacy-policy" class="sidebar-link">
            <span>Privacy</span>
            <span>›</span>
          </router-link>
        </li>

        <li>
          <router-link
            to="/request-profile-deletion"
            class="sidebar-link text-red"
          >
            <span>Delete account</span>
            <span>›</span>
          </router-link>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { computed } from "vue";
import store from "@/store";

export default {
  setup() {
    const author = computed(() => store.state.editProfile.editingProfile);

    const profileCompletion = computed(() => {
      if (!author.value) {
        return {
          percentage: 0,
          hasDisplayName: false,
          hasDescription: false,
          hasProfilePhoto: false,
        };
      }

      let percentage = 0;

      const hasDisplayName =
        author.value.name && author.value.name.trim().length > 0;

      const hasDescription =
        author.value.description && author.value.description.trim().length > 0;

      const hasProfilePhoto =
        author.value.yka_avatar_url &&
        !author.value.yka_avatar_url.includes("default") &&
        !author.value.yka_avatar_url.includes("avatar");

      if (hasDisplayName) percentage += 33;
      if (hasDescription) percentage += 33;
      if (hasProfilePhoto) percentage += 34;

      return {
        percentage,
        hasDisplayName,
        hasDescription,
        hasProfilePhoto,
      };
    });

    return {
      author,
      profileCompletion,
    };
  },
};
</script>
<style scoped>
.profile-label {
  @apply block text-sm font-bold uppercase tracking-wide text-gray mb-3;
}

.sidebar-link {
  @apply flex items-center justify-between
  hover:text-yka-blue transition;
}
</style>
